import React from "react";
import { FaTimes } from 'react-icons/fa';
import { formatDateTime } from "../Constants/constant";
import { FaCheckCircle } from "react-icons/fa";
import Dropdown from "./Dropdown";
import InputField from "./InputField";
import CloseModal from "./CloseModal";
import BasicButton from "./Buttons";

const FilterPanel = ({show, onChange, onClose, onFilter, onClear, filterData, filterList = {}, loading, loadingFilter }) => {
    const uploadStatusOptions = [
        {value:"1", label: "All"},
        {value:"2", label: "Uploaded"},
        {value:"3", label: "Not Uploaded"},
    ];
  return (
    <>
      {/* Overlay */}
      {show && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={()=> {if(!loading && !loadingFilter) onClose()}}
        />
      )}

      {/* Slide-in Panel */}
      <div
        className={`fixed top-2 right-2 h-[97vh] w-[500px] bg-white shadow-lg border-l rounded-lg border-gray-200 z-50 transform transition-transform duration-400 ease-in-out ${
          show ? "translate-x-0" : "translate-x-[110%]"
        } overflow-hidden`}
      >
        {/* Header */}
        {/* <div className="text-xl p-4 m-1 border-b flex justify-between items-center darkPurple font-semibold text-white rounded-lg"> */}
        <h1 className="m-0 text-left text-lg font-semibold py-4 px-3">Filters
            <div className=" grid grid-cols-2 gap-2">
                    <div className=" flex flex-col">
                        {/* <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Apply Filter</label> */}
                        <BasicButton onClick={onFilter} buttonName='Apply Filter' className='darkPurple text-nowrap' shadow={true}
                        disabled={loading || loadingFilter || (!filterData?.fromDate && !filterData?.toDate && 
                        !filterData?.candidateName && !filterData?.email && !filterData?.phone && !filterData?.jobTitle && 
                        !filterData?.currentLocation && !filterData?.preferredLocation && !filterData?.currentCompany && 
                        !filterData?.currentDesignation && !filterData?.minExperience && !filterData?.maxExperience && !filterData?.uploadStatus
                        && !filterData?.dobFromDate && !filterData?.dobToDate && !filterData?.qualification && !filterData?.minAnnualSalary && !filterData?.maxAnnualSalary)} 
                        loading={loadingFilter === "1"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
                    </div>
                    <div className=" flex flex-col">
                        {/* <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Clear Filter</label> */}
                        <BasicButton onClick={onClear} buttonName='Clear Filter' className="bg-red-600 text-nowrap" shadow={true}
                        disabled={loading || loadingFilter || (!filterData?.fromDate && !filterData?.toDate && 
                        !filterData?.candidateName && !filterData?.email && !filterData?.phone && !filterData?.jobTitle && 
                        !filterData?.currentLocation && !filterData?.preferredLocation && !filterData?.currentCompany && 
                        !filterData?.currentDesignation && !filterData?.minExperience && !filterData?.maxExperience && !filterData?.uploadStatus
                        && !filterData?.dobFromDate && !filterData?.dobToDate && !filterData?.qualification && !filterData?.minAnnualSalary && !filterData?.maxAnnualSalary)} 
                        loading={loadingFilter === "2"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-red-900" />
                    </div>
                </div>
        </h1>
        <CloseModal disabled={loading || loadingFilter} onClick={onClose} />
        {/* </div> */}
        <div className="h-[80%] overflow-auto mb-20">
            <div className="px-3 py-2 grid grid-cols-2 gap-2">
                <InputField  id="fromDate" name="fromDate" type="date" label="From:"
                disabled={loading}
                value={filterData?.fromDate}
                onChange={onChange}
                />
                <InputField  id="toDate" name="toDate" type="date" label="To:"
                disabled={loading}
                value={filterData?.toDate}
                onChange={onChange}
                />
                <Dropdown id="uploadStatus" name="uploadStatus" label="Upload Status:"
                    onChange={onChange}
                    className=" rounded border border-gray-300 w-full text-[0.8rem]"
                    placeholder={`Select`}
                    disabled={loading}
                    value={filterData?.uploadStatus}
                    options={uploadStatusOptions}
                />
                <InputField  id="resume_updated_datetime" name="resume_updated_datetime" type="date" label="Resume Updated Dt:"
                disabled={loading}
                value={filterData?.resume_updated_datetime}
                onChange={onChange}
                />
                {/* <InputField  id="candidateName" name="candidateName" type="text" label="Candidate:"
                placeholder="Enter Name"
                disabled={loading}
                value={filterData?.candidateName}
                onChange={onChange}
                /> */}
                <InputField  id="email" name="email" type="text" label="Email:"
                placeholder="Enter Email"
                disabled={loading}
                value={filterData?.email}
                onChange={onChange}
                />
                <InputField  id="phone" name="phone" type="text" label="Mobile:"
                placeholder="Enter Mobile"
                disabled={loading}
                value={filterData?.phone}
                onChange={onChange}
                />
                <InputField  id="jobTitle" name="jobTitle" type="text" label="Job Title:"
                placeholder="Enter Job Title"
                disabled={loading}
                value={filterData?.jobTitle}
                onChange={onChange}
                />
                <InputField  id="currentLocation" name="currentLocation" type="text" label="Current Location:"
                placeholder="Enter Current Location"
                disabled={loading}
                value={filterData?.currentLocation}
                onChange={onChange}
                />
                <InputField  id="preferredLocation" name="preferredLocation" type="text" label="Preferred Location:"
                placeholder="Enter Preferred Location"
                disabled={loading}
                value={filterData?.preferredLocation}
                onChange={onChange}
                />
                <InputField  id="currentCompany" name="currentCompany" type="text" label="Current Company:"
                placeholder="Enter Current Company"
                disabled={loading}
                value={filterData?.currentCompany}
                onChange={onChange}
                />
                <InputField  id="currentDesignation" name="currentDesignation" type="text" label="Current Designation:"
                placeholder="Enter Current Designation"
                disabled={loading}
                value={filterData?.currentDesignation}
                onChange={onChange}
                />
                <InputField  id="minExperience" name="minExperience" type="text" label="Min Experience:"
                placeholder="Enter Min Experience"
                disabled={loading}
                value={filterData?.minExperience}
                onChange={onChange}
                />
                <InputField  id="maxExperience" name="maxExperience" type="text" label="Max Experience:"
                placeholder="Enter Max Experience"
                disabled={loading}
                value={filterData?.maxExperience}
                onChange={onChange}
                />
                <InputField  id="industry" name="industry" type="text" label="Industry  :"
                placeholder="Enter Industry"
                disabled={loading}
                value={filterData?.industry}
                onChange={onChange}
                />
                <InputField  id="skills" name="skills" type="text" label="Skills:"
                placeholder="Enter skills"
                disabled={loading}
                value={filterData?.skills}
                onChange={onChange}
                />
                <InputField  id="qualification" name="qualification" type="text" label="Qualifications:"
                placeholder="Eg: B.Sc., B.com etc."
                disabled={loading}
                value={filterData?.qualification}
                onChange={onChange}
                />
                <InputField  id="minAnnualSalary" name="minAnnualSalary" type="text" label="Min Annual Salary:"
                placeholder="Enter min annual salary"
                disabled={loading}
                value={filterData?.minAnnualSalary}
                onChange={onChange}
                />
                <InputField  id="maxAnnualSalary" name="maxAnnualSalary" type="text" label="Max Annual Salary:"
                placeholder="Enter max annual salary"
                disabled={loading}
                value={filterData?.maxAnnualSalary}
                onChange={onChange}
                />
            </div>
        </div>
        

      </div>
    </>
  );
};

export default FilterPanel;
